<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择" default-value="0" @keyup.enter.native="$refs.table.refresh(true)">
                <a-select-option value="">全部</a-select-option>
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.WarehouseSubTransferStatus">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-row :gutter="48">
            <a-col :md="4" :sm="24">
              <a-form-item label="保税商品">
                <a-select
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  allow-clear
                  @keyup.enter.native="$refs.table.refresh(true)"
                  v-model="queryParam.bonded_commodity_id"
                  placeholder="保税商品"
                  @search="handleBondedCommoditySearch"
                  @change="handleBondedCommodityChange"
                >
                  <a-select-option v-for="d in dataSource_bonded_commodity" :key="d.id" :tt="d.bonded_goods.name + '(' + d.batch+ ')'">
                    {{ d.bonded_goods.name + '(' + d.batch+ ')' }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="保税仓库" class="goodslist">
                <a-auto-complete
                  allow-clear
                  v-model="queryParam.bonded_warehouse_id"
                  @keyup.enter.native="$refs.table.refresh(true)"
                  placeholder="保税仓库"
                  @search="onSearchBondedWarehouse"
                >
                  <template slot="dataSource">
                    <a-select-option v-for="item in dataSourceBondedWarehouse" :tt="item.name" :key="item.id + ''">
                      {{ item.name }}
                    </a-select-option>
                  </template>
                </a-auto-complete>
                <span>{{ tip_bonded_warehouse }}</span>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="展示商品">
                <a-select
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  @keyup.enter.native="$refs.table.refresh(true)"
                  allow-clear
                  v-model="queryParam.exhibition_commodity_id"
                  placeholder="保税商品"
                  @search="handleExhibitionCommoditySearch"
                  @change="handleExhibitionCommodityChange"
                >
                  <a-select-option v-for="d in dataSourceExhibitionCommodity" :key="d.id" :tt="d.name">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="展示仓库">
                <a-select
                  option-label-prop="tt"
                  show-search
                  allow-clear
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  @keyup.enter.native="$refs.table.refresh(true)"
                  v-model="queryParam.exhibition_warehouse_id"
                  placeholder="展示仓库"
                  :default-active-first-option="false"
                  @search="handleExhibitionWarehouseSearch"
                  @change="handleExhibitionWarehouseChange"
                >
                  <a-select-option v-for="d in dataSource_exhibition_warehouse" :key="d.id" :tt="d.name">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="2" :sm="24">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </a-col>
          </a-row>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="middle"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="count_render" slot-scope="text" style="text-align: right; min-width: 70px; max-width: 80px">
        {{ text }}
      </div>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 70px; max-width: 80px">
        {{ (text / 100).toFixed(2) }}
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleUpdate(record, 2)" v-if="record.status === 1">出库</a>
          <a @click="handleUpdate(record, 3)" v-if="record.status === 2">入库</a>
          <a-divider type="vertical" v-if="record.status === 1"/>
          <a @click="handleDelet(record)" v-if="record.status === 1">删除</a>
        </template>
      </span>
    </s-table>
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import AAutoComplete from 'ant-design-vue/es/auto-complete/'
import {
  warehouse_sub_transfer_delete,
  warehouse_sub_transfer_list,
  warehouse_sub_transfer_update
} from '@/api/warehouse'
import { bonded_commodity_list } from '@/api/bonded_commodity'
import { exhibition_commodity_list } from '@/api/exhibition_commodity'
import { exhibition_warehouse_list } from '@/api/exhibition_warehouse'
import { bonded_warehouse_list } from '@/api/bonded_warehouse'

export default {
  name: 'Read',
  components: {
    STable,
    AAutoComplete
  },
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      exhibition_warehouse_value: '',
      exhibition_goods_value: '',
      bonded_commodity_value: '',
      dataSource_exhibition_warehouse: [],
      dataSource_exhibition_goods: [],
      dataSource_bonded_commodity: [],
      dataSourceBondedWarehouse: [],
      tip_bonded_warehouse: '',
      dataSourceExhibitionWarehouse: [],
      tip_exhibition_warehouse: '',
      dataSourceExhibitionCommodity: [],
      tip_exhibition_commodity: '',
      dataSourceCommodity: [],
      tip_commodity: '',
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '50px',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '保税仓库',
          dataIndex: 'bonded_warehouse',
          ellipsis: true
        },
        {
          title: '保税商品',
          dataIndex: 'bonded_commodity',
          ellipsis: true
        },
        {
          title: '保税库位',
          dataIndex: 'bonded_cargo_space',
          ellipsis: true
        },
        {
          title: '保税数量',
          dataIndex: 'bonded_count',
          align: 'center',
          scopedSlots: { customRender: 'count_render' }
        },
        {
          title: '展示仓库',
          dataIndex: 'exhibition_warehouse',
          ellipsis: true
        },
        {
          title: '展示货物',
          dataIndex: 'exhibition_commodity',
          ellipsis: true
        },
        {
          title: '展示数量',
          dataIndex: 'exhibition_count',
          scopedSlots: { customRender: 'count_render' },
          align: 'center'
        },
        {
          title: '税',
          dataIndex: 'tax',
          align: 'center',
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '方向',
          dataIndex: 'direction',
          customRender: (text) => this.$Dictionaries.WarehouseTransferDirection[text],
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'status',
          customRender: (text) => this.$Dictionaries.WarehouseSubTransferStatus[text],
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return warehouse_sub_transfer_list(Object.assign(parameter, this.queryParam, { transfer_id: this.$route.query.id }))
          .then(res => {
            return res.data
          })
      }
    }
  },
  created () {},
  methods: {
    //  commodity
    handleBondedCommoditySearch (value) {
      bonded_commodity_list({ name: value }).then((res) => {
        let result = res.data.entries || []
        console.log(result, '98989')
        this.dataSource_bonded_commodity = !value ? [] : result
      })
    },
    handleBondedCommodityChange (value) {
      this.queryParam.bonded_commodity_id = value
      this.bonded_commodity_value = value
    },
    //  exhibition_commodity
    onSearchExhibitionCommodity (searchText) {
      exhibition_commodity_list({ name: searchText }).then((res) => {
        const result = res.data.entries || []
        if (result.length === 0) {
          this.tip_exhibition_commodity = '未找到您输入的商品'
        } else {
          this.tip_exhibition_commodity = ''
        }
        this.dataSourceExhibitionCommodity = !searchText ? [] : result
      })
    },
    handleExhibitionCommoditySearch (value) {
      exhibition_commodity_list({ name: value }).then((res) => {
        let result = res.data.entries || []
        this.dataSourceExhibitionCommodity = !value ? [] : result
      })
    },
    handleExhibitionCommodityChange (value) {
      this.queryParam.exhibition_commodity_id = value
    },
    //  exhibition_warehouse
    handleExhibitionWarehouseSearch (value) {
      exhibition_warehouse_list({ name: value }).then((res) => {
        let result = res.data.entries || []
        this.dataSource_exhibition_warehouse = !value ? [] : result
      })
    },
    handleExhibitionWarehouseChange (value) {
      this.queryParam.exhibition_warehouse_id = value
    },
    //  exhibition_warehouse
    onSearchBondedWarehouse (searchText) {
      bonded_warehouse_list({ name: searchText }).then((res) => {
        const result = res.data.entries || []
        if (result.length === 0) {
          this.tip_bonded_warehouse = '未找到您输入的仓库'
        } else {
          this.tip_bonded_warehouse = ''
        }
        this.dataSourceBondedWarehouse = !searchText ? [] : result
      })
    },
    handleDelet (record) {
      warehouse_sub_transfer_delete(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')

        this.$refs.table.refresh()
      })
    },
    handleUpdate (record, target) {
      warehouse_sub_transfer_update({ target: target }, record.id).then((res) => {
        this.$refs.table.refresh()
      })
      .catch((err) => {
        console.log(err)
        this.$refs.table.refresh()
      })
    }
  }
}
</script>
<style lang="less">
  .goodslist .ant-select-selection--single .ant-select-selection__rendered {
    margin-right: 0px !important;
  }
  .goodslist .ant-select-selection__rendered {
    position: relative;
    display: block;
    margin-right: 0px;
    margin-left: 0px;
    line-height: 30px;
  }
</style>
